import React, { Component } from "react";
import "./HeaderVideo.css";
import Aux from "../../../hoc/Aux/Aux";
import ModalVideos from "../../General/ModalVideos/ModalVideos";
import { prefix } from "../../../scripts/helpers/constants";
import { Play } from "../../General/Svgs/SVGs";

class HeaderVideo extends Component {
  state = {
    open: false
  };

  modalClicked = () => {
    this.setState({ open: true });
  };

  handleHide = () => {
    this.setState({ open: false });
  };

  handleHideKey = event => {
    if (event.keyCode === 27) {
      this.setState({ open: false });
    }
  };

  componentWillMount() {
    document.addEventListener("keydown", this.handleHideKey, false);
  }

  render() {
    return (
      <Aux>
        <a onClick={this.modalClicked} className={prefix + "-c-header-video"}>
          <p className="p2 header-video-play-title first">{this.props.videoFirstTitle}</p>
          <i className="header-video-play">
            <Play reference="svg-icon header-video-play-icon" />
          </i>
          <p className="p2 header-video-play-title second">{this.props.videoSecondTitle}</p>
        </a>
        <ModalVideos
          show={this.state.open}
          modalClosed={this.handleHide}
          videoCode={this.props.videoCode}
        />
      </Aux>
    );
  }
}

export default HeaderVideo;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderVideo/HeaderVideo.js